/**
 *
 * Styles for WCCMultiBUOfferDeliveryInfo
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";

export const EstimatedDeliveryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: var(--gaq-size-space-5px);
  margin-bottom: 15px;

  @media screen and (min-width: ${breakpoints.desktop}) {
    line-height: 24px;
    flex-direction: row;
    display: inline-flex;
    margin-bottom: 8px;
  }
`;

export const EstimatedDeliveryContainerText = styled(DhlText)`
  margin-bottom: var(--dui-size-space-5x);
`;

export const StyledAdditionalInfo = styled(DhlText)`
  display: inline;

  & > *:is(p, span) {
    display: inline;
  }
`;

export const InformationTextWrapper = styled.div`
  margin-top: var(--dui-size-space-5x);

  > .icon {
    display: inline;
    margin-right: var(--gaq-size-space-5px);
  }
`;

export const StyledMappedLocation = styled(DhlText)`
  display: inline;

  & > *:is(p, span) {
    display: inline;
    line-height: 20px;
  }
`;

export const ContentWrapper = styled.div`
  order: 1;
  width: 100%;

  @media screen and (min-width: ${breakpoints.tablet}) {
    order: 2;
    padding-right: var(--gaq-size-space-30px);
  }
`;

export const DeliveryInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > .icon {
    order: 2;
    height: 100%;
    width: 100%;
    text-align: right;
    max-width: 72px;
    align-self: flex-end;
    margin-bottom: auto;
  }

  &.wcc-aggregated-card > .icon {
    order: 1;
    position: absolute;
    right: 1.5rem;
    top: 0.625rem;

    @media screen and (min-width: ${breakpoints.tablet}) {
      position: unset;
      top: unset;
      right: unset;
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    align-items: center;

    > .icon {
      margin-right: var(--gaq-size-space-30px);
      margin-bottom: 0;
      order: 1;
      text-align: left;
      height: auto;
      width: auto;
      max-width: unset;
      align-self: unset;
    }
  }

  &.wcc-aggregated-card ${ContentWrapper} {
    margin-top: 0.4rem;
  }
`;

export const DeliveryDateHeadline = styled(Headline)`
  margin: 0;
  white-space: normal;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 33.5rem;
  }
`;

export const DeliveryTimeText = styled(DhlText)`
  margin-top: calc(var(--dui-size-space-7x) / 2);
  font-size: 2rem;
  font-weight: 200;
  font-stretch: condensed;
  font-style: normal;

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
    padding-left: var(--dui-size-space-5x);
    margin-left: var(--dui-size-space-5x);
    border-left: var(--dui-size-width-border-sm) solid var(--dui-color-gray-300);

    &.text--giga.text--giga {
      line-height: 1;
    }
  }
`;
